const redirectToJobber = () => {
  if (import.meta.env.NODE_ENV === "test") return;
  window.location.href = "https://getjobber.com/";
};

export default redirectToJobber;
